import { useFormik, FormikConfig } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createRank, editRank, seeListRanks } from '../../actions/awardsActions'
import RanksAdminView from '../../containers/RanksAdmin/RanksAdminView'

const RanksAdmin = () => {
  const dispatch = useDispatch()
  const { listRanks } = useSelector(state => state.awardsAdmin)
  const [isEdit, setIsEdit] = useState(false)
  const [idRank, setIdRank] = useState(null)
  useEffect(() => {
    dispatch(seeListRanks())

    return () => {

    }
  }, [])

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      requiredScore: 0
    },
    onSubmit: ({ name, description, requiredScore, image }) => {
      const formData = new FormData()
      formData.append("name", name)
      formData.append("image", image)
      formData.append("thumbnailImage", image)
      formData.append("grayImage", image)
      formData.append("description", description)
      formData.append("requiredScore", requiredScore)
      if (!isEdit) {
        dispatch(createRank(formData))
      } else {

        formData.append("levelID", idRank)
        dispatch(editRank(formData))
      }

    }

  })

  return (
    <RanksAdminView setIdRank={setIdRank} formik={formik} listRanks={listRanks} isEdit={isEdit} setIsEdit={setIsEdit} />
  )
}

export default RanksAdmin



